import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AUDIT_LOG_SEARCH_RESOURCE } from "../audit-log/use-audit-log-search.query";

export const RELOCATION_ORDER_UPDATE_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_UPDATE_API_PATH = `/v1/${RELOCATION_ORDER_UPDATE_RESOURCE}/{uuid}` as const;

export type RelocationOrderUpdateBody =
  paths[typeof RELOCATION_ORDER_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type RelocationOrderUpdateResponse =
  paths[typeof RELOCATION_ORDER_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

type RelocationOrderUpdateMutationPayload = RelocationOrderUpdateBody & { uuid: string };

export const useRelocationOrderUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<RelocationOrderUpdateResponse, Error, RelocationOrderUpdateMutationPayload>({
    mutationFn: async (relocationOrder: RelocationOrderUpdateMutationPayload) => {
      const { uuid, ...rest } = relocationOrder;
      const response = await alphartisApiAxios.patch<RelocationOrderUpdateResponse>(
        `/v1/${RELOCATION_ORDER_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [RELOCATION_ORDER_UPDATE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [AUDIT_LOG_SEARCH_RESOURCE],
        }),
      ]);
    },
  });
};
